function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.5,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.793,8.981L1.237,8.981C0.888,8.981 0.572,8.788 0.41,8.48C0.248,8.172 0.272,7.8 0.468,7.515L4.858,1.18C5.012,0.954 5.27,0.82 5.544,0.821C5.821,0.822 6.076,0.957 6.23,1.184L10.561,7.519C10.758,7.806 10.779,8.176 10.617,8.483C10.455,8.789 10.139,8.981 9.793,8.981ZM1.237,11.018L9.793,11.018C10.139,11.018 10.455,11.21 10.617,11.517C10.779,11.824 10.758,12.194 10.561,12.48L6.23,18.816C6.076,19.042 5.821,19.178 5.544,19.179C5.27,19.18 5.012,19.046 4.858,18.82L0.468,12.485C0.272,12.199 0.248,11.827 0.41,11.519C0.572,11.212 0.888,11.018 1.237,11.018Z",
    style: {
      fill: "rgb(10,45,113)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.7e1e3d248095316d65b1d0f7bf57fa61.svg";
export { ForwardRef as ReactComponent };